<template>
  <div class="taskList">
    <!-- {{taskList.length}} -->
    <van-pull-refresh class="taskList" v-model="refreshing" @refresh="onRefresh">
      <!-- <button @click="test">test</button> -->
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div
          v-for="item in taskList"
          :key="item.id"
          class="taskItem flex-center"
          @click="$router.push('/get?taskId=' + item.task_id)"
        >
          <van-image
            class="taskImg"
            :src="require('../../../assets/image/tags/qita.png')"
          />
          <div class="taskRight">
            <h5>
              <p>{{ item.title }}</p>
              <span class="fontCenter" v-if="item.max_pick"
                >限定{{ item.max_pick }}人</span
              >
            </h5>
            <div class="labels flex-center">
              <div class="label fontCenter color1">
                {{ item.task_mech }}
              </div>
              <template v-if="item.task_tag">
                <div
                  class="label fontCenter color2"
                  v-for="(childItem, childIndex) in strToArr(item.task_tag)"
                  :key="childIndex"
                >
                  {{ childItem }}
                </div>
              </template>

              <div class="label fontCenter color3" v-if="item.urgent_level == '紧急'">
                {{ item.urgent_level }}
              </div>
            </div>
            <p class="flex-center">
              <span>{{ item.plan_start_time }}-{{ item.plan_end_time }}</span>
              <span>发布人: {{ item.createby_name }}</span>
            </p>
            <div class="taskBottom flex-center">
              <div class="prise">
                <img src="@/assets/image/prise.png" alt="" />
                <span>{{ moneyFormat(item.award) }}</span>
              </div>
              <template>
                <div class="receive" @click.stop="receive(item)">
                  <span :class="{ can: isReceiveFn(item).isReceive }">{{
                    isReceiveFn(item).statusText
                  }}</span>

                  <!-- <span
                    class="fontCenter"
                    v-if="
                      item.task_mech === '悬赏' &&
                      (item.max_pick == 0 || item.pink < item.max_pick)
                    "
                  >
                    领取任务 
                  </span>
                  <span class="fontCenter" v-else-if="item.pink < item.max_pick">
                    领取任务({{ item.pink }}/{{ item.max_pick }})
                  </span>
                  <span class="fontCenter not" v-else @click.stop="">该任务已被领取</span> -->
                </div>
              </template>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <nothing-com v-if="taskList.length == 0">
      <div slot="tip"></div>
    </nothing-com>

    <Model-dialog :visible.sync="receiveDialogShow" @confirm="confirm">
      <div slot="title">确定领取任务“{{ activeTitle }}”？</div>
      <div slot="tip">请提前与任务接收人沟通</div>
    </Model-dialog>
  </div>
</template>

<script>
import { getNotTakeTasksApi, getInTask } from "@/api/api/task";
export default {
  /**
   * 任务列表组件
   */
  name: "taskList",
  props: {
    type: {},
    searchVal: {},
    tag: {},
  },
  watch: {
    searchVal(e) {
      this.queryForm.task_name = e;
    },
    tag(e) {
      this.queryForm.task_tag = e;
    },
  },
  data() {
    return {
      receiveDialogShow: false,
      loading: false,
      finished: false,
      refreshing: false,
      queryForm: {
        type: this.type,
        page: 0,
        limit: 10,
        task_tag: this.tag,
        task_name: this.searchVal,
      },
      taskList: [],
      total: null,
      activeTitle: "",
      activeId: 0,
      task_count: {},
    };
  },
  methods: {
    test() {
      console.log("loading", this.loading);
      console.log("finished", this.finished);
    },
    async getData() {
      this.loading = true;
      if (this.total == this.taskList.length) {
        this.finished = true;
        this.loading = false;
        return console.log("没有更多了");
      }
      this.refreshing = true;
      this.queryForm.page++;
      let res = await getNotTakeTasksApi(this.queryForm);
      console.log(res);
      this.taskList = [...this.taskList, ...res.data.data.list];
      if (res.data.data.total == 0) this.finished = true;
      this.total = res.data.data.total;
      this.$emit("setTotal", res.data.data.task_count);
      this.refreshing = false;
      this.loading = false;
    },
    initData() {},
    onLoad() {
      console.log("Load");
      this.getData();
    },
    onRefresh() {
      this.queryForm.page = 0;
      this.total = null;
      this.taskList = [];
      this.finished = false;
      this.getData();
    },
    receive(item) {
      if (this.isReceiveFn(item).isReceive) {
        this.activeTitle = item.title;
        this.activeId = item.task_id;
        this.receiveDialogShow = true;
      }
    },
    async confirm() {
      let res = await getInTask(this.activeId);
      console.log(res);
      this.receiveDialogShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.taskList {
  margin-top: 22px;
}

.taskItem {
  height: 100px;
  margin-top: 36px;
  padding: 0 15px;

  .taskImg {
    width: 100px;
    height: 100px;
  }

  .taskRight {
    flex: 1;
    margin-left: 13px;
    height: 100%;
    border-bottom: 1px solid #d8d8d8;

    h5 {
      display: flex;
      align-items: center;
      justify-content: space-between;

      p {
        margin: 0;
        width: 150px;
        height: 20px;
        font-size: 14px;
        line-height: 20px;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      span {
        width: 50px;
        height: 16px;
        background: #0800f9;
        border-radius: 11px;
        color: #fff;
        font-size: 10px;
      }
    }

    .labels {
      margin-top: 5px;
      justify-content: flex-start;

      .label {
        padding: 0 6px;
        height: 16px;
        font-size: 10px;
        color: #ffffff;
        margin-right: 5px;
        border-radius: 50%;
      }
    }

    p {
      justify-content: space-between;
      font-size: 11px;
      color: #979797;
      margin-top: 8px;
      height: 15px;
      line-height: 15px;
    }

    .taskBottom {
      justify-content: space-between;
      margin-top: 8px;

      .prise {
        display: flex;
        align-items: center;

        img {
          width: 15px;
          height: 15px;
          margin-right: 5px;
        }
      }

      .receive {
        > span {
          padding: 4px 8px;
          height: 20px;
          background-color: #ccc;

          border-radius: 11px;
          font-size: 12px;
          color: #fff;
        }

        .can {
          background: #ff7a15;
        }
      }
    }
  }

  &:first-child {
    margin-top: 0;
  }
}
</style>
